module.exports = __webpack_public_path__ + "img/Ici.d68f7736.png";